import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';
import {Resultate} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m2';

@Component({
  selector: '[appTableDataRowResultat]',
  templateUrl: './table-resultate-data-row.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TableDataRowResultatComponent
  extends CurrentLocaleComponent
  implements OnInit
{
  @Input() rowdata: Resultate;
  @Input() rowPropName: string;
  @Input() rowHeader: string;

  constructor(protected readonly translate: TranslateService) {
    super(translate);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
